import { api } from '../../shared/api/client'
import type { EntityRelations, RelationComponent } from './types'

const unwrap = (response: any) => response.data?.data ?? response.data

const asRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {}

const toComponent = (raw: unknown): RelationComponent | null => {
  const value = asRecord(raw)
  const article = String(value.article ?? value.componentArticle ?? value.parentArticle ?? '').trim()
  if (!article) return null
  const quantity = Number(value.quantity)
  const position = Number(value.position)
  return {
    article,
    title: value.title == null || value.title === '' ? null : String(value.title),
    quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
    position: Number.isFinite(position) ? position : null,
  }
}

const toComponentList = (raw: unknown): RelationComponent[] =>
  (Array.isArray(raw) ? raw : []).map(toComponent).filter((entry): entry is RelationComponent => entry !== null)

/** Узлы `products[]` несут `components` (состав набора PP1) и `usedIn` (наборы, куда входит PP0): массивы. */
export const normalizeProductComponents = <T extends object>(product: T): T & { components: RelationComponent[]; usedIn: RelationComponent[] } => {
  const value = asRecord(product)
  return { ...product, components: toComponentList(value.components), usedIn: toComponentList(value.usedIn) }
}

export const entityRelationsAPI = {
  async get(params: {
    article?: string
    designCode?: string
    signal?: AbortSignal
  }): Promise<EntityRelations> {
    const response = await api.get('/products/relations', {
      params: {
        article: params.article || undefined,
        designCode: params.designCode || undefined,
      },
      signal: params.signal,
    })
    const data = unwrap(response)
    if (!data || typeof data !== 'object' || !Array.isArray(data.products)) return data
    return { ...data, products: data.products.map(normalizeProductComponents) }
  },
}
